var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-template',{attrs:{"contentOnly":true,"minHeight":400 + 'px'},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('ImgChange',{on:{"close":_vm.closeMe,"logout":_vm.logout}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }